export default {
  initSections(state, payload) {
    state.selectedView = payload.selectedView;
    state.sections = payload.sections;
    state.inviewElement = payload.element;
  },
  setGaDataLayer(state, payload) {
    state.dataLayer = payload;
  },
  setBraintreeOptions(state, payload) {
    state.braintreeOptions = payload;
  },
  setDirectDebitEnabled(state, payload) {
    state.enableDirectDebit = payload;
  },
  setPreSelectedMembershipCategory(state, payload) {
    state.memberCategory = payload;
  },
  pushToDataLayer(state, payload) {
    state.dataLayer.push(payload);
  },
  savePaymentOption(state, payload) {
    state.paymentOption = payload;
  },
  changeSelectedView(state, payload) {
    state.selectedView = payload.view;
  },
  completeUnderstandingYou(state, payload) {
    if (state.application === null) { throw new Error('No application initialised'); }
    const { type } = payload;
    state.application.UnderstandingYou[type] = payload.understandingYou;
    state.application.Type = type;
  },
  completePersonalDetails(state, payload) {
    state.personalDetailsJson = payload.personalDetails;
  },
  completeCorrespondence(state, payload) {
    const correspondence = { ...payload, userId: state.application?.UserInfo?.userId };

    state.application.Correspondence = correspondence;
  },
  completeInsurance(state, payload) {
    state.application.Insurance = payload.insurance;
  },
  saveSectionOffset(state, payload) {
    state.sectionOffset = payload.offSet;
  },
  setArea(state, payload) {
    const currentAreaObject = state.areas.filter((area) => area.name === payload.selectedArea)[0];
    state.currentArea = currentAreaObject;
  },
  setApplication(state, payload) {
    state.application = payload;
  },
  setIdentityVerification(state, payload) {
    state.identityVerification = payload;
  },
  setCardPaymentResult(state, payload) {
    state.cardPaymentResult = payload;
    state.paymentOption = { TotalAmountDue: payload.amount };
    state.identityVerification = { success: true };
  },
  setOverseasStatus(state, payload) {
    state.application.Correspondence.isOverseas = payload.isOverseas;
  },
  disableProgressBar(state, payload) {
    state.areas.forEach((a) => {
      const area = a;
      area.clickable = payload;
    });
  },
  setOptions(state, payload) {
    state.understandingYouOptions = payload;
  },
  setPaymentOptions(state, payload) {
    state.paymentOptions = payload;
  },
  setPaymentOptionsInfo(state, payload) {
    state.paymentOptionsInfo = payload;
  },
  addOpportunity(state, payload) {
    state.application.AuthorisationUrl = payload?.AuthorisationUrl;
    state.application.OpportunityId = payload?.OpportunityId;
  },
  updateAreasWithOrWithoutInsuranceOption(state, payload) {
    const isPliCategory = state.pliMembershipCategories.find((c) => c === payload);
    let initStepValue = 0;
    let initProgressValue = 0;
    const stepIncrease = 1;
    const progressIncrease = isPliCategory ? 20 : 25;

    state.areas.forEach((a) => {
      if (isPliCategory || a.name !== 'Insurance') {
        a.stepValue = initStepValue;
        a.progressValue = initProgressValue;
        a.visible = true;
        initStepValue += stepIncrease;
        initProgressValue += progressIncrease;
      } else {
        a.stepValue = -1;
        a.progressValue = -1;
        a.visible = false;
      }
    });
  },
};
